
<h1 mat-dialog-title>Edit Lectionary Item Type</h1>

<div mat-dialog-content>

  <p>What's your favorite animal?</p>


  <div class="form-material">
    <input matInput [(ngModel)]="item.Localized[0].Name">
  </div>




LectionaryItemType.ReligionBranchID
<BR>
LectionaryItemType.LanguageStyle

<BR>


LectionaryItemTypeLocalized.LectionaryItemTypeID

<BR>
LectionaryItemTypeLocalized.LanguageCode

<BR>
LectionaryItemTypeLocalized.Name

<BR>
LectionaryItemTypeLocalized.Description

<BR>
LectionaryItemTypeLocalized.HyperlinkID[ ]

  <button class="btn btn-sm btn-outline-secondary float-right" (click)="add()">
    <i class="fa fa-plus mr-5"></i>Add Lectionary Item Type
  </button>

</div>
<div mat-dialog-actions>
  <button mat-button  >No Thanks</button>
  <button mat-button   >Ok</button>
</div>
